/**
 * InsideSalesDashboard - Container Principal
 * Organiza os dashboards em 8 seções correspondentes aos slides dos PDFs:
 * PDF1: Slides 2-5 (Avaliação de Desempenho)
 * PDF2: Slides 2-5 (Resultados Iniciais e Projeção)
 */
import React, { useState } from "react";

// Componente de Filtros Globais
import GlobalFilters from "./GlobalFilters";
import DashboardErrorBoundary from "./DashboardErrorBoundary";

// PDF1 - Avaliação de Desempenho
import CadastroMedicos from "./CadastroMedicos";
import ResumoVisitas from "./ResumoVisitas";
import RegistroOcorrencias from "./RegistroOcorrencias";
import DadosRelevantes from "./DadosRelevantes";

// PDF2 - Resultados Iniciais e Projeção
import VisitasContato from "./VisitasContato";
import BaseMedicosOrigem from "./BaseMedicosOrigem";
import GeograficoEspecialidades from "./GeograficoEspecialidades";
import ProjecaoMetas from "./ProjecaoMetas";

const InsideSalesDashboard = ({ programaId }) => {

  // Estado de filtros globais
  const [globalFilters, setGlobalFilters] = useState({
    year: new Date().getFullYear(),
    month: null, // null = todos os meses
  });

  // Handler para atualização de filtros
  const handleFiltersChange = (newFilters) => {
    setGlobalFilters(newFilters);
  };

  // Componente de divisor de seção
  const SectionDivider = ({ title, subtitle }) => (
    <div className="row mt-5 mb-3">
      <div className="col-12">
        <div className="p-3 bg-white shadow-sm rounded border-start border-5 border-primary">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h4 className="fw-bold text-dark m-0">{title}</h4>
              {subtitle && <small className="text-muted">{subtitle}</small>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="container-fluid p-4 bg-light" style={{ minHeight: "100vh" }}>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold m-0">Dashboard Inside Sales</h2>
      </div>

      {/* Filtros Globais */}
      <GlobalFilters filters={globalFilters} onFiltersChange={handleFiltersChange} />

      {/* PDF 1 - AVALIAÇÃO DE DESEMPENHO              */}

      {/* Seção 1: Cadastro de Médicos (PDF1 Slide 2) */}
      <SectionDivider
        title="1. Cadastro de Médicos"
        subtitle="Evolução mensal de médicos ativos e status de cadastro"
      />
      <DashboardErrorBoundary label="CadastroMedicos">
        <CadastroMedicos programaId={programaId} filters={globalFilters} />
      </DashboardErrorBoundary>

      {/* Seção 2: Resumo de Visitas (PDF1 Slide 3) */}
      <SectionDivider
        title="2. Resumo de Visitas"
        subtitle="Volume de visitas, distribuição mensal e taxa de revisitas"
      />
      <DashboardErrorBoundary label="ResumoVisitas">
        <ResumoVisitas programaId={programaId} filters={globalFilters} />
      </DashboardErrorBoundary>

      {/* Seção 3: Registro de Ocorrências (PDF1 Slide 4) */}
      <SectionDivider
        title="3. Registro de Ocorrências"
        subtitle="Tentativas de contato sem retorno"
      />
      <DashboardErrorBoundary label="RegistroOcorrencias">
        <RegistroOcorrencias programaId={programaId} filters={globalFilters} />
      </DashboardErrorBoundary>

      {/* Seção 4: Dados Relevantes (PDF1 Slide 5) */}
      <SectionDivider
        title="4. Visitas - Dados Relevantes"
        subtitle="Análise detalhada das informações coletadas durante as visitas"
      />
      <DashboardErrorBoundary label="DadosRelevantes">
        <DadosRelevantes programaId={programaId} filters={globalFilters} />
      </DashboardErrorBoundary>

      {/* PDF 2 - RESULTADOS INICIAIS E PROJEÇÃO       */}

      <div className="row mt-5">
        <div className="col-12">
          <hr className="border-2 border-dark" />
        </div>
      </div>

      {/* Seção 5: Visitas e Via de Contato (PDF2 Slide 2) */}
      <SectionDivider
        title="5. Dashboard Recordati - Visitas e Via de Contato"
        subtitle="Visitas por período, revisitas e canais de contato utilizados"
      />
      <DashboardErrorBoundary label="VisitasContato">
        <VisitasContato programaId={programaId} filters={globalFilters} />
      </DashboardErrorBoundary>

      {/* Seção 6: Base de Médicos (PDF2 Slide 3) */}
      <SectionDivider
        title="6. Dashboard Recordati - Base de Médicos"
        subtitle="Status da base atual e origem dos médicos visitados"
      />
      <DashboardErrorBoundary label="BaseMedicosOrigem">
        <BaseMedicosOrigem programaId={programaId} filters={globalFilters} />
      </DashboardErrorBoundary>

      {/* Seção 7: Geográfico + Especialidades (PDF2 Slide 4) */}
      <SectionDivider
        title="7. Distribuição Geográfica e Especialidades"
        subtitle="Mapa de médicos por estado e ranking de especialidades"
      />
      <DashboardErrorBoundary label="GeograficoEspecialidades">
        <GeograficoEspecialidades programaId={programaId} filters={globalFilters} />
      </DashboardErrorBoundary>

      {/* Seção 8: Projeções e Metas (PDF2 Slide 5) */}
      <SectionDivider
        title="8. Projeções e Metas 2025"
        subtitle="Quadro de metas mensal e gráfico de projeção"
      />
      <DashboardErrorBoundary label="ProjecaoMetas">
        <ProjecaoMetas programaId={programaId} filters={globalFilters} />
      </DashboardErrorBoundary>

      {/* Footer spacing */}
      <div className="mb-5" />
    </div>
  );
};

export default InsideSalesDashboard;
